<template>
  <div class="footer-page">
    <van-tabbar v-model="active">
      <van-tabbar-item
        v-for="(item, index) in items"
        :key="index"
        :name="item.key"
        @click="toPage(item)"
      >
        <template #icon="props">
          <svg-icon
            :icon-class="item.key"
            :class="props.active ? 'footer-icon-select' : 'footer-icon'"
          />
        </template>
        <span>{{ item.value }}</span>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "WebFooter",
  data() {
    return {
      active: 'home',
      items: [
        { key: "home", value: this.$t("footer.home") },
        { key: "market", value: this.$t("footer.market") },
        { key: "exchange", value: this.$t("footer.exchange") },
        { key: "options", value: this.$t("footer.options") },
        { key: "assets", value: this.$t("footer.assets") },
      ],
    };
  },
  mounted(){
    this.active = this.$route.name
  },
  methods: {
    toPage(item) {
      if (item.key !== "home") this.$router.push({ name: item.key }, () => {});
      else this.$router.push({ path: "/" }, () => {});
    },
  },
};
</script>

<style>
</style>
